import { TextField, Autocomplete } from "@mui/material";
import { useState, useEffect, type SyntheticEvent } from "react";

type AliveOption = {
  alive: number;
  name: string;
};

const aliveOptions: AliveOption[] = [
  { alive: 0, name: "無" },
  { alive: 1, name: "有" },
  { alive: 9, name: "設定しない" },
];

type AliveSelectProps = {
  changedValue: (value: number | undefined) => void;
  inputValue: number;
};

export default function AliveSelect({
  changedValue,
  inputValue,
}: AliveSelectProps) {
  const initialValue = aliveOptions.find(
    (element) => element.alive === parseInt(String(inputValue), 10)
  );
  const [value, setValue] = useState<AliveOption | undefined>(initialValue);

  useEffect(() => {
    if (inputValue !== undefined && inputValue !== null) {
      const newValue = aliveOptions.find((item) => item.alive === inputValue);
      setValue(newValue);
    }
  }, [inputValue]);

  const handleChange = (
    _event: SyntheticEvent,
    newValues: AliveOption | null
  ) => {
    setValue(newValues ?? undefined);
    changedValue(newValues?.alive);
  };

  return (
    <Autocomplete
      fullWidth
      size="small"
      options={aliveOptions}
      getOptionLabel={(pref) => pref.name}
      isOptionEqualToValue={(option, selected) =>
        option.alive === selected.alive
      }
      renderInput={(params) => <TextField {...params} />}
      onChange={handleChange}
      value={value ?? null}
      sx={{ cursor: "pointer", pointerEvents: "auto" }}
    />
  );
}
